import type { RawData } from "@albertine/analytics-client";
import type { ChatAnalyticsMessage } from "@albertine/types";
import { parentOriginFromLocation, postMessageToParentFrame } from "@/lib/parentFrame";

export function trackChatAnalytics(
    eventName: ChatAnalyticsMessage["event_name"],
    rawData?: RawData,
): void {
    const payload: ChatAnalyticsMessage = {
        type: "chat.analytics",
        event_name: eventName,
        raw_data: rawData,
    };

    postMessageToParentFrame(parentOriginFromLocation(), payload);
}
